import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { EditApifonIntegrationSystem } from 'src/app/modules/administration/integration-management/actions/apifon-configuration.actions';
import { EditEliquaCXIntegrationSystem } from 'src/app/modules/administration/integration-management/actions/eliqua-cx-configuration.actions';
import { EditEnboxIntegrationSystem } from 'src/app/modules/administration/integration-management/actions/enbox-configuration.actions';
import {
  ChangeSidenavStatus,
  ChangeStatusSystem,
  OpenConfirmDialogForDeleteRow,
} from 'src/app/modules/administration/integration-management/actions/integration-management-actions.actions';
import { EditNeverbounceIntegrationSystem } from 'src/app/modules/administration/integration-management/actions/neverbounce-configuration.actions';
import { EditQcMessageAppIntegrationSystem } from 'src/app/modules/administration/integration-management/actions/qc-message-app-configuration.actions';
import { EditSesIntegrationSystem } from 'src/app/modules/administration/integration-management/actions/ses-configuration.actions';
import { EditOmniIntegrationSystem } from 'src/app/modules/administration/integration-management/actions/omni-configuration.actions';
import { IntegrationType } from 'src/app/modules/administration/integration-management/models/create-new-integration.model';
import { ApifonConfigurationFacadeService } from 'src/app/modules/administration/integration-management/services/apifon-configuration.facade.service';
import { EliquaCXConfigurationFacadeService } from 'src/app/modules/administration/integration-management/services/eliqua-cx-configuration.facade.service';
import { EnboxConfigurationFacadeService } from 'src/app/modules/administration/integration-management/services/enbox-configuration.facade.service';
import { IMCreateNewFacadeService } from 'src/app/modules/administration/integration-management/services/integration-management-create-new.facade.service';
import { NeverbounceConfigurationFacadeService } from 'src/app/modules/administration/integration-management/services/neverbounce-configuration.facade.service';
import { QcMessageAppConfigurationFacadeService } from 'src/app/modules/administration/integration-management/services/qc-message-app-configuration.facade.service';
import { SesConfigurationFacadeService } from 'src/app/modules/administration/integration-management/services/ses-configuration.facade.service';
import { OmniConfigurationFacadeService } from 'src/app/modules/administration/integration-management/services/omni-configuration.facade.service';
import {
  ChangeCheckedStatus,
  NewLiteralsPagingChanged,
} from 'src/app/modules/administration/locale-management/actions/import-export-literals.actions';
import {
  EditLiteral,
  LiteralsPagingChanged,
} from 'src/app/modules/administration/locale-management/actions/search-literals.actions';
import { EditUserPolicy } from 'src/app/modules/administration/user-management/actions/policy-document.actions';
import { EditSecGroup } from 'src/app/modules/administration/user-management/actions/security-groups.actions';
import { OpenSidenav, UpdateUser } from 'src/app/modules/administration/user-management/actions/side-nav.actions';
import {
  ActivateFlow,
  DeactivateFlowModal,
} from 'src/app/modules/automation-center/flows/actions/search-flows.actions';
import { SearchFlowsFacadeService } from 'src/app/modules/automation-center/flows/services/search-flows.facade.service';
import {
  EditRecipe,
  OpenActivateRecipeModal,
  OpenDeactivateRecipeModal,
  OpenSideNav,
} from 'src/app/modules/automation-center/recipes/actions/search.actions';
import { SearchRecipesFacadeService } from 'src/app/modules/automation-center/recipes/services/search.facade.service';
import {
  CancelCampaignModal,
  OpenCEUpdateCostDialog,
  OpenCEUpdateDateDialog,
  OpenDownloadCRDialog,
} from 'src/app/modules/campaign-management/campaign-executions/actions/search.actions';
import { GridCampaignSearchResponse } from 'src/app/modules/campaign-management/campaign-executions/models/campaign-management.model';
import { CampaignManagementFacadeService } from 'src/app/modules/campaign-management/campaign-executions/services/search.facade.service';
import {
  campaignExecutionsCountInit,
  campaignExecutionsInit,
  loadColumns,
} from 'src/app/modules/campaign-management/campaigns/actions/campaign-executions.actions';
import {
  ActivateCampaignInit,
  OpenCampaignDeactivationModal,
  OpenCampaignDuplicateModal,
  OpenCampaignNotesModal,
  OpenCampaignSendModal,
  EditCampaignInit,
} from 'src/app/modules/campaign-management/campaigns/actions/campaign-search.actions';
import { DownloadList, OpenDeleteListModal } from 'src/app/modules/campaign-management/campaigns/actions/lists.actions';
import {
  LoadPreviewListCols,
  PreviewListByFilter,
  PreviewListForMembers,
  PreviewListForPerson,
} from 'src/app/modules/campaign-management/campaigns/actions/preview-list.actions';
import {
  ShowCampaignExecutions,
  ShowPreviewList,
} from 'src/app/modules/campaign-management/campaigns/actions/sidenav.actions';
import { Target } from 'src/app/modules/campaign-management/campaigns/models/lists.model';
import { CampaignSearchFacadeService } from 'src/app/modules/campaign-management/campaigns/services/campaign-search.facade.service';
import { ListsFacadeService } from 'src/app/modules/campaign-management/campaigns/services/lists.facade.service';
import { PreviewListFacadeService } from 'src/app/modules/campaign-management/campaigns/services/preview-list.facade.service';
import { LoadAssignCheckbookCols } from 'src/app/modules/campaign-management/checkbooks/actions/assign-checkbook.actions';
import { LoadCheckbookDetailsCols } from 'src/app/modules/campaign-management/checkbooks/actions/checkbook-details.actions';
import {
  EditCheckbookGroupTemplate,
  LoadCheckbookGroupTemplateCols,
} from 'src/app/modules/campaign-management/checkbooks/actions/checkbook-group-template.actions';
import {
  AssignSelectedCheckbookDetailsData,
  GetMeToMember,
  OpenDialogForUnassignCheckbook,
} from 'src/app/modules/campaign-management/checkbooks/actions/search-checkbooks-actions.actions';
import { ChangeGroupTemplatesStatus } from 'src/app/modules/campaign-management/checkbooks/actions/search-group-templates.actions';
import {
  AssignCheckbook,
  OpenCheckbookDetailsSidenav,
} from 'src/app/modules/campaign-management/checkbooks/actions/sidenav.actions';
import { AssignCheckbookFacadeService } from 'src/app/modules/campaign-management/checkbooks/services/assign-checkbook.facade.service';
import { CheckbookGroupTemplateFacadeService } from 'src/app/modules/campaign-management/checkbooks/services/checkbook-group-template.facade.service';
import { SearchCheckbooksFacadeService } from 'src/app/modules/campaign-management/checkbooks/services/search-checkbooks.facade.service';
import { SearchGroupTemplatesFacadeService } from 'src/app/modules/campaign-management/checkbooks/services/search-group-templates.facade.service';
import { SidenavFacadeService } from 'src/app/modules/campaign-management/checkbooks/services/sidenav.facade.service';
import {
  ActivateClub,
  DeleteClubConfirm,
  EditClub,
} from 'src/app/modules/customer-data/clubs/actions/clubs-search.actions';
import { ClubState } from 'src/app/modules/customer-data/clubs/models/clubs.models';
import { ViewMember } from 'src/app/modules/customer-data/customers/actions/lmembers-summary.actions';
import {
  ViewCustomer,
  EditCustomer,
} from 'src/app/modules/customer-data/customers/actions/all-customers-summary.actions';
import { AllCustomersFacadeService } from 'src/app/modules/customer-data/customers/services/all-customers.facade.service';
import { MembersSearchFacadeService } from 'src/app/modules/customer-data/customers/services/members-search.facade.service';
import { SharedFacadeService } from 'src/app/modules/customer-data/customers/services/shared.facade.service';
import {
  CancelInfoInvoice,
  InvoiceDetails,
  InvoiceShowAttributes,
  InvoiceShowCoupons,
} from 'src/app/modules/customer-data/invoices/actions/invoice-info.actions';
import { InvoiceModal } from 'src/app/modules/customer-data/invoices/actions/invoices.actions';
import { InvoicesFacadeService } from 'src/app/modules/customer-data/invoices/services/invoices.facade.service';
import { EditTicket } from 'src/app/modules/customer-data/tickets/actions/tickets-search.actions';
import {
  Assignment,
  Category,
  Schema,
  Severity,
  Status,
  TicketRow,
} from 'src/app/modules/customer-data/tickets/models/tickets.models';
import { TicketsSearchFacadeService } from 'src/app/modules/customer-data/tickets/services/tickets-search.facade.service';
import { AddNewConfEditData } from 'src/app/modules/customer-operations/bulk-operations/actions/bulk-add-new.actions';
import { OpenErrorsSidenav } from 'src/app/modules/customer-operations/bulk-operations/actions/bulk-history.actions';
import {
  AssignErrorId,
  LoadErrorLogsCols,
  LogOrderingInit,
  LogSortingInit,
} from 'src/app/modules/customer-operations/bulk-operations/actions/error-logs-actions';
import {
  ChangeBulkActiveStatus,
  OpenAddNewConfSidenav,
} from 'src/app/modules/customer-operations/bulk-operations/actions/search-bulk.actions';
import { NewBulkOperation } from 'src/app/modules/customer-operations/bulk-operations/actions/side-nav.actions';
import { EditStateRow } from 'src/app/modules/data-customization/store-management/models/store.model';
import { StoreSearchFacadeService } from 'src/app/modules/data-customization/store-management/services/search.facade.service';
import { OpenUpdateDateDialog } from 'src/app/modules/data-customization/tag-management/actions/edit-date.actions';
import { EditDateFacadeService } from 'src/app/modules/data-customization/tag-management/services/edit-date.facade.service';
import { UpdateTagFacadeService } from 'src/app/modules/data-customization/tag-management/services/update-tag.facade.service';
import { EditSchema } from 'src/app/modules/loyalty-model/schemas/actions/search.actions';
import { DownloadCardBatch as DownloadCardBatchRow } from 'src/app/modules/loyalty-model/schemas/actions/card-batches.actions';
import { GridSchemaSearchResponse } from 'src/app/modules/loyalty-model/schemas/models/schemas.model';
import { SchemasSearchFacadeService } from 'src/app/modules/loyalty-model/schemas/services/search.facade.service';
import {
  OpenEditSidenav,
  SchemaChanged,
  DeleteRedemptionRule,
} from 'src/app/modules/loyalty-model/redeem-rules/actions/create-new.actions';
import { RedeemRulesSearchFacadeService } from 'src/app/modules/loyalty-model/redeem-rules/services/search.facade.service';
import { CreateNewFacadeService as RedeemRulesCreateNewFacadeService } from 'src/app/modules/loyalty-model/redeem-rules/services/create-new.facade.service';
import { TabIndexChange } from 'src/app/modules/merchant/actions/details.actions';
import { MerchantPageChanged } from 'src/app/modules/merchant/actions/search.actions';
import {
  EditCouponset,
  SearchMerchant,
  UnbindStoreModal,
  ViewMerchantInfo,
} from 'src/app/modules/merchant/actions/summary.actions';
import { MerchantSummaryFacadeService } from 'src/app/modules/merchant/services/summary.facade.service';
import { IntegrationManagementActionsFacadeService } from '../../../modules/administration/integration-management/services/integration-management-actions.facade.service';
import {
  EditFlow,
  OpenSidenav as OpenFlowsSidenav,
  ViewFlow,
} from '../../../modules/automation-center/flows/actions/sidenav.actions';
import {
  ActivateStore,
  DeactivateStoreModal,
  EditStore,
  GetLocaleData,
  TableCountryCodeChanged,
} from '../../../modules/data-customization/store-management/actions/search.actions';
import { OpenUpdateTagDialog } from '../../../modules/data-customization/tag-management/actions/update-tag.actions';
import {
  ActivateStore as SummaryActivateStore,
  DeactivateStoreModal as SummaryDeactivateStoreModal,
} from '../../../modules/merchant/actions/summary.actions';
import { ActiveComponentChanged } from '../../actions/eliqua.actions';
import { DeselectedRowData, SelectedRowDataChanged } from '../../actions/grid.actions';
import { PagingChanged } from '../../actions/paginator.actions';
import { ActionColumnsLiterals, ActiveComponent, Paginator } from '../../models/grid.model';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { BreakpointFacadeService } from '../../services/breakpoint.facade.service';
import { EliquaFacadeService } from '../../services/eliqua.facade.service';
import { EnvironmentFacadeService } from '../../services/environment.facade.service';
import { GridFacadeService } from '../../services/grid.facade.service';
import { LiteralsFacadeService } from '../../services/literals.facade.service';
import { BulkLiteralsFacadeService } from '../../services/literals/bulk.literals.facade.service';
import { CampaignSearchLiteralsFacadeService } from '../../services/literals/campaign-search.literals.facade.service';
import { CampaignManagementLiteralsFacadeService } from '../../services/literals/capmaign-management.literals.facade.service';
import { ClubsLiteralsFacadeService } from '../../services/literals/clubs.literals.facade.service';
import { InvoiceLiteralsFacadeService } from '../../services/literals/invoices.literals.facade.service';
import { PaginatorLiteralsFacadeService } from '../../services/literals/paginator.literals.facade.service';
import { RecipesLiteralsFacadeService } from '../../services/literals/recipes.literals.facade.service.';
import { SchemasLiteralsFacadeService } from '../../services/literals/schemas.literals.facade.service';
import { StoreLiteralsFacadeService } from '../../services/literals/store.literals.facade.service';
import { SystemLiteralsFacadeService } from '../../services/literals/system.literals.facade.service';
import { TagManagementLiteralsFacadeService } from '../../services/literals/tag-management.literals.facade.service';
import { TicketsLiteralsFacadeService } from '../../services/literals/tickets.literals.facade.service';
import { UserManagementLiteralsFacadeService } from '../../services/literals/user-managements.literals.facade.service';
import { PaginatorFacadeService } from '../../services/paginator.facade.service';
import { ProgressFacadeService } from '../../services/progress.facade.service';
import { RolesFacadeService } from '../../services/roles.facade.service';
import { MAT_MENU_SCROLL_STRATEGY } from '@angular/material/menu';
import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';
@Component({
  selector: 'dragonfly-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: MAT_MENU_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay): (() => ScrollStrategy) => {
        return () => overlay.scrollStrategies.close({ threshold: 1 });
      },
      deps: [Overlay],
    },
  ],
  standalone: false,
})
export class GridComponent {
  constructor(
    private router: Router,
    private paginatorLiterals: PaginatorLiteralsFacadeService,
    private environmentFacade: EnvironmentFacadeService,
    private environmentFacadeService: EnvironmentFacadeService,
    private campaignMFacade: CampaignManagementFacadeService,
    private schemasSearchFacade: SchemasSearchFacadeService,
    private merchantSummaryFacade: MerchantSummaryFacadeService,
    public literalsFacade: LiteralsFacadeService,
    public systemLiterals: SystemLiteralsFacadeService,
    public tagLiterals: TagManagementLiteralsFacadeService,
    public userLiterals: UserManagementLiteralsFacadeService,
    public invoicesFacade: InvoicesFacadeService,
    public bulkLiterals: BulkLiteralsFacadeService,
    public clubLiteralsFacade: ClubsLiteralsFacadeService,
    public cmLiterals: CampaignManagementLiteralsFacadeService,
    public schemasLiterals: SchemasLiteralsFacadeService,
    public ticketsLiterals: TicketsLiteralsFacadeService,
    public storeLiterals: StoreLiteralsFacadeService,
    public facade: GridFacadeService,
    public breakpointFacadeService: BreakpointFacadeService,
    public eliquaFacadeService: EliquaFacadeService,
    public progressFacade: ProgressFacadeService,
    public paginatorFacade: PaginatorFacadeService,
    public integrationManagementActionsFacadeService: IntegrationManagementActionsFacadeService,
    public enboxFacadeService: EnboxConfigurationFacadeService,
    public neverbounceFacadeService: NeverbounceConfigurationFacadeService,
    public apifonFacadeService: ApifonConfigurationFacadeService,
    public createNewIntegrationFacadeService: IMCreateNewFacadeService,
    public updateTagFacadeService: UpdateTagFacadeService,
    public editDateFacadeService: EditDateFacadeService,
    public qcMessageAppFacadeService: QcMessageAppConfigurationFacadeService,
    public sesFacadeService: SesConfigurationFacadeService,
    public eliquaCXFacadeService: EliquaCXConfigurationFacadeService,
    public omniFacadeService: OmniConfigurationFacadeService,
    public invoiceLiterals: InvoiceLiteralsFacadeService,
    public searchCheckbooksFacadeService: SearchCheckbooksFacadeService,
    public searchGroupTemplatesFacadeService: SearchGroupTemplatesFacadeService,
    public searchCheckbookSidenavFacade: SidenavFacadeService,
    public assignCheckbookFacade: AssignCheckbookFacadeService,
    public checkbookGroupTemplateFacade: CheckbookGroupTemplateFacadeService,
    public listsFacadeService: ListsFacadeService,
    public previewListFacadeService: PreviewListFacadeService,
    public ticketsSearchFacade: TicketsSearchFacadeService,
    public searchFlowsFacade: SearchFlowsFacadeService,
    public storeFacade: StoreSearchFacadeService,
    public recipesFacade: SearchRecipesFacadeService,
    public recipesLiterals: RecipesLiteralsFacadeService,
    public rolesFacade: RolesFacadeService,
    public lmFacade: MembersSearchFacadeService,
    public acFacade: AllCustomersFacadeService,
    private customerSharedFacade: SharedFacadeService,
    public campaignSearchFacadeService: CampaignSearchFacadeService,
    public campaignSearchLiterals: CampaignSearchLiteralsFacadeService,
    private redeemRulesSearchFacade: RedeemRulesSearchFacadeService,
    private redeemRulesCreateNewFacade: RedeemRulesCreateNewFacadeService,
    private dialog: MatDialog,
  ) {}

  public actions = ActionColumnsLiterals;

  pagingChanged(e: PageEvent) {
    const paginator = e as Paginator;
    if (this.eliquaFacadeService.activeComponent === 'ImportExportLiteralsComponent') {
      this.paginatorFacade.dispatch(NewLiteralsPagingChanged({ paginator }));
    } else if (this.eliquaFacadeService.activeComponent === 'LiteralsSearchComponent') {
      this.paginatorFacade.dispatch(LiteralsPagingChanged({ paginator }));
    } else this.paginatorFacade.dispatch(PagingChanged({ paginator }));
  }

  deactivateRecipe(element: any) {
    this.facade.dispatch(OpenDeactivateRecipeModal({ recipeCode: element.recipeCode }));
  }

  activateRecipe(element: any) {
    this.facade.dispatch(OpenActivateRecipeModal({ recipe: element }));
  }

  editData(row: any, columnKey?: string, columnVal?: string) {
    switch (this.eliquaFacadeService.activeComponent) {
      case ActiveComponent.SearchTags:
        this.facade.dispatch(OpenUpdateTagDialog({ row }));
        break;
      case ActiveComponent.TagAssignment:
        if (columnKey && columnVal)
          this.facade.dispatch(
            OpenUpdateDateDialog({
              dateFormat: row[columnVal],
              column: columnKey,
            }),
          );
        break;
      case ActiveComponent.SearchIntegration:
        const integrationType = row.integrationConfig.integrationSystem;
        this.integrationManagementActionsFacadeService.dispatch(ChangeSidenavStatus());

        switch (integrationType) {
          case IntegrationType.ELIQUA_CX:
            this.eliquaCXFacadeService.dispatch(EditEliquaCXIntegrationSystem({ eliquaCXData: row }));
            break;
          case IntegrationType.ENBOX:
            this.enboxFacadeService.dispatch(EditEnboxIntegrationSystem({ enboxData: row }));
            break;
          case IntegrationType.NEVERBOUNCE:
            this.enboxFacadeService.dispatch(EditNeverbounceIntegrationSystem({ neverbounceData: row }));
            break;
          case IntegrationType.APIFON_SMS:
          case IntegrationType.APIFON_VIBER_SMS:
            this.enboxFacadeService.dispatch(EditApifonIntegrationSystem({ apifonData: row }));
            break;
          case IntegrationType.QC_MESSAGE_APP:
            this.qcMessageAppFacadeService.dispatch(EditQcMessageAppIntegrationSystem({ qcMessageAppData: row }));
            break;
          case IntegrationType.AWS_SES:
            this.sesFacadeService.dispatch(EditSesIntegrationSystem({ sesData: row }));
            break;
          case IntegrationType.MSTAT_VIBER_SMS_V2:
            this.omniFacadeService.dispatch(EditOmniIntegrationSystem({ omniData: row }));
            break;
        }
        break;
      case ActiveComponent.SearchBulk:
        this.facade.dispatch(AddNewConfEditData({ row }));

        this.facade.dispatch(OpenAddNewConfSidenav());
        break;
      case ActiveComponent.BulkHistory:
        this.facade.dispatch(
          AssignErrorId({
            importJobId: row.importJobId,
          }),
        );

        const displayedColumns: { [column: string]: string } = {
          [this.bulkLiterals.logId]: 'logId',
          [this.bulkLiterals.logDate]: 'logDate',
          [this.bulkLiterals.logMessage]: 'logMessage',
        };

        const sortFieldOptions = [this.bulkLiterals.logDateChanged];

        const orderFieldOptions = [this.paginatorLiterals.orderDesc, this.paginatorLiterals.orderAsc];

        this.facade.dispatch(
          LogSortingInit({
            sortFieldOptions,
            selectedSortField: '',
          }),
        );

        this.facade.dispatch(
          LogOrderingInit({
            orderFieldOptions,
            selectedOrder: this.paginatorLiterals.orderDesc,
          }),
        );

        this.facade.dispatch(LoadErrorLogsCols({ displayedColumns }));
        this.facade.dispatch(OpenErrorsSidenav());
        break;
      case ActiveComponent.UserSearch:
        this.facade.dispatch(UpdateUser({ row }));
        this.facade.dispatch(OpenSidenav());
        break;
      case ActiveComponent.UserPolicyDocuments:
        this.facade.dispatch(EditUserPolicy({ row }));
        this.facade.dispatch(OpenSidenav());
        break;
      case ActiveComponent.UserSecurityGroups:
        this.facade.dispatch(EditSecGroup({ row }));
        this.facade.dispatch(OpenSidenav());
        break;
      case ActiveComponent.FlowRecipes:
        this.recipesFacade.dispatch(EditRecipe({ row }));
        this.recipesFacade.dispatch(OpenSideNav());
        break;
      case ActiveComponent.SearchCheckbooks:
        this.facade.dispatch(
          AssignSelectedCheckbookDetailsData({
            selectedCheckbookDetailsData: row.bookCouponList,
          }),
        );

        const displayedCheckbookDetailsColumns: { [column: string]: string } = {
          [this.literalsFacade.literals.literals['liquid.coupon.couponid']]: 'couponId',
          [this.literalsFacade.literals.literals['system.couponset.id']]: 'couponSetId',
          [this.literalsFacade.literals.literals['liquid.coupon.code']]: 'couponCode',
          [this.literalsFacade.literals.literals['liquid.coupon.used']]: 'used',
          [this.literalsFacade.literals.literals['system.coupon.couponuseddate']]: 'dateUsed',
          [this.literalsFacade.literals.literals['liquid.coupon.validfrom']]: 'validFromDate',
          [this.literalsFacade.literals.literals['liquid.coupon.validuntil']]: 'validUntilDate',
        };

        this.facade.dispatch(LoadCheckbookDetailsCols({ displayedColumns: displayedCheckbookDetailsColumns }));
        this.facade.dispatch(OpenCheckbookDetailsSidenav());
        break;
      case ActiveComponent.SearchGroupTemplates:
        this.checkbookGroupTemplateFacade.dispatch(EditCheckbookGroupTemplate({ data: row }));
        const displayedTemplatesLinesColumns: { [column: string]: string } = {
          [`${this.literalsFacade.literals.literals['liquid.checkbook.couponset']} *`]: '',
          [`${this.literalsFacade.literals.literals['liquid.checkbook.batchnumber']} *`]: '',
          [`${this.literalsFacade.literals.literals['liquid.checkbook.prefix']} *`]: '',
          ['Delete']: '',
        };

        this.checkbookGroupTemplateFacade.dispatch(
          LoadCheckbookGroupTemplateCols({ displayedColumns: displayedTemplatesLinesColumns }),
        );
        break;
      case ActiveComponent.ClubSearch:
        this.facade.dispatch(EditClub({ row }));
        break;
      case ActiveComponent.CampaignExecutions:
        if (columnVal && columnKey === this.cmLiterals.date)
          this.facade.dispatch(OpenCEUpdateDateDialog({ row, columnVal }));
        if (columnVal && columnKey === this.cmLiterals.tableCost)
          this.facade.dispatch(OpenCEUpdateCostDialog({ row, columnVal }));
        if (columnVal && columnKey === 'CampaignExecutions') this.facade.dispatch(OpenDownloadCRDialog({ row }));
        break;
      case ActiveComponent.LiteralsSearch:
        this.facade.dispatch(EditLiteral({ row }));
        break;
      case ActiveComponent.Schemas:
        this.facade.dispatch(EditSchema({ row }));
        break;
      case ActiveComponent.CardBatchesSearch:
        this.facade.dispatch(DownloadCardBatchRow({ cardBatchId: row.cardBatchId }));
        break;
      case ActiveComponent.RedeemRules:
        const searchResponse = this.redeemRulesSearchFacade.lastSearchResponse;
        if (searchResponse) {
          const ruleIndex = searchResponse.redemptionLevelRules.findIndex(
            (r: any) =>
              r.redemptionType === row.redemptionType &&
              r.points === row.points &&
              r.memberCategoryCode === row.memberCategoryCode &&
              r.memberStatusCode === row.memberStatusCode &&
              r.memberTagCode === row.memberTagCode,
          );
          const schema = this.redeemRulesSearchFacade.schemas.find(
            (s) => s.loyaltySchemaCode === searchResponse.loyaltySchemaCode,
          );
          if (schema) {
            this.redeemRulesCreateNewFacade.dispatch(
              SchemaChanged({ schemaCode: schema.loyaltySchemaCode, schemaId: schema.id }),
            );
          }
          this.redeemRulesCreateNewFacade.dispatch(
            OpenEditSidenav({ rule: row, ruleIndex: ruleIndex >= 0 ? ruleIndex : 0 }),
          );
        }
        break;
      default:
        null;
    }
  }

  matchRowWithColumn(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element?.[path[i]];
    }
    return element ?? '';
  }

  matchMerchantStoreAddress(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element?.[path[i]];
    }
    return element
      ? element.addressLine1
        ? element.addressLine1
        : element.addressLine2
          ? element.addressLine2
          : element.addressLine3
      : '-';
  }

  matchCEIDwithCountry(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element[path[i]];
    }
    return element
      ? this.campaignMFacade.countryOptions.filter((country) => country.countryId === element)[0].country
      : '-';
  }

  matchCEIDwithSchema(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element[path[i]];
    }
    return element
      ? this.campaignMFacade.schemaOptions.filter((schema) => schema.id === element)[0].loyaltySchemaName
      : '-';
  }
  matchIDwithSchemaRewardRules(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element[path[i]];
    }
    return element ? this.recipesFacade.schemas.filter((schema) => schema.id === element)[0].loyaltySchemaName : '-';
  }

  matchIDwithSchemaCampaignSearch(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element[path[i]];
    }
    return element
      ? this.campaignSearchFacadeService.schemas.filter((schema) => schema.id === element)[0].loyaltySchemaName
      : '-';
  }

  matchCEIDwithCountryCampaignSearch(element: any, columnTag: string) {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element[path[i]];
    }
    return element
      ? this.campaignSearchFacadeService.countries.filter((country) => country.id === element)[0].country
      : '-';
  }

  matchCEIDwithCategoryCampaignSearch(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    const categoryId = path.reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : undefined), element);
    const foundCategory = this.campaignSearchFacadeService.categories.find((cat) => cat.id === categoryId);

    return foundCategory ? this.literalsFacade.literals.literals[foundCategory.description] : '-';
  }

  matchRowWithColumnCampaignSearch(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element?.[path[i]];
    }
    return element ?? null;
  }

  campaignSearchStatus(element: any): string {
    let status = '';
    if (!element.expired && !element.deleteFlag) {
      status = 'Active';
    } else if (element.deleteFlag) {
      status = 'Deleted';
    } else if (element.expired && !element.deleteFlag) {
      status = 'Expired';
    }
    return status;
  }

  campaignSearchSend(campaign: any) {
    this.facade.dispatch(OpenCampaignSendModal({ campaign }));
  }

  campaignSearchUpdate(row: any) {
    this.facade.dispatch(EditCampaignInit({ row }));
  }

  campaignSearchNotes(notes: string) {
    this.facade.dispatch(OpenCampaignNotesModal({ notes }));
  }

  campaignSearchDuplicate(campaign: any) {
    this.facade.dispatch(OpenCampaignDuplicateModal({ campaign }));
  }

  campaignSearchActivationStatus(campaign: any) {
    if (!campaign.deleteFlag) {
      this.facade.dispatch(OpenCampaignDeactivationModal({ campaign }));
    } else {
      this.facade.dispatch(ActivateCampaignInit({ campaign }));
    }
  }

  showCampaignExecutionsPanel(campaign: any) {
    this.facade.dispatch(ShowCampaignExecutions({ campaign }));

    const displayedCampaignExecutionsColumns: { [column: string]: string } = {
      [this.literalsFacade.literals.literals['liquid.campaign.executionsid']]: 'id',
      [this.literalsFacade.literals.literals['liquid.campaign.executionstitle']]: 'title',
      [this.literalsFacade.literals.literals['liquid.campaign.executionsdescription']]: 'description',
      [this.literalsFacade.literals.literals['liquid.campaign.executionsdate']]: 'date',
      [this.literalsFacade.literals.literals['liquid.campaign.executionscountry']]: 'country',
      [this.literalsFacade.literals.literals['liquid.campaign.executionsschema']]: 'schema',
      [this.literalsFacade.literals.literals['liquid.campaign.executionschannel']]: 'channel',
      [this.literalsFacade.literals.literals['liquid.campaign.executionscost']]: 'cost',
      [this.literalsFacade.literals.literals['liquid.campaign.executionsgroup'] + ' %']: 'group',
      [this.literalsFacade.literals.literals['liquid.campaign.executionsrecipients']]: 'members',
      ['Campaign Executions Actions']: '',
    };

    this.facade.dispatch(loadColumns({ columns: displayedCampaignExecutionsColumns }));
    this.facade.dispatch(campaignExecutionsCountInit());
    this.facade.dispatch(campaignExecutionsInit());
  }

  matchSchemaCompanyIdName(element: GridSchemaSearchResponse) {
    const company = this.schemasSearchFacade.companies.filter((company) => company.companyId === element.companyId);
    return company.length ? (company[0].companyName ?? '-') : '-';
  }

  matchCustomerWithSchema(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element[path[i]];
    }

    return element
      ? this.lmFacade.schemaNameOptions.filter((schema) => schema.id === element)[0].loyaltySchemaName
      : '-';
  }

  matchCustomerWithStore(element: any, columnTag: string): string {
    const path = columnTag.split('.');
    for (let i = 0; i < path.length; i++) {
      element = element[path[i]];
    }

    return element
      ? (this.literalsFacade.literals.literals[
          this.lmFacade.registrationStoreOptions
            .filter((store) => store.id === element)?.[0]
            ?.description?.toLowerCase()
        ] ?? '-')
      : '-';
  }

  stopRowDataFlow(event: Event, element: any) {
    if (this.facade.selectedId === element.id) event.stopPropagation();
  }

  selectedRow(row: any) {
    if (row.id === this.facade.selectedId) {
      this.facade.dispatch(DeselectedRowData());
    } else {
      this.facade.dispatch(SelectedRowDataChanged({ row }));
    }
  }

  changeRowStatus(row: any, columnKey?: string, columnVal?: string) {
    switch (this.eliquaFacadeService.activeComponent) {
      case ActiveComponent.SearchIntegration:
        this.integrationManagementActionsFacadeService.dispatch(ChangeStatusSystem({ data: row }));
        break;
      case ActiveComponent.SearchBulk:
        this.bulkLiterals.dispatch(ChangeBulkActiveStatus({ bulkConfiguration: row }));
        break;
      case ActiveComponent.SearchGroupTemplates:
        this.searchCheckbooksFacadeService.dispatch(ChangeGroupTemplatesStatus({ data: row }));
        break;
      default:
        break;
    }
  }

  deleteRowData(row: any, columnKey?: string, columnVal?: string) {
    switch (this.eliquaFacadeService.activeComponent) {
      case ActiveComponent.SearchIntegration:
        this.integrationManagementActionsFacadeService.dispatch(OpenConfirmDialogForDeleteRow());
        break;
      case ActiveComponent.Lists:
        this.listsFacadeService.dispatch(OpenDeleteListModal());
        break;
      default:
        return;
    }
  }

  newBulkOperation(row: any) {
    this.facade.dispatch(NewBulkOperation({ row }));
  }

  deleteRedeemRule(row: any) {
    const searchResponse = this.redeemRulesSearchFacade.lastSearchResponse;
    if (!searchResponse) return;

    const ruleIndex = searchResponse.redemptionLevelRules.findIndex(
      (r: any) =>
        r.redemptionType === row.redemptionType &&
        r.points === row.points &&
        r.memberCategoryCode === row.memberCategoryCode &&
        r.memberStatusCode === row.memberStatusCode &&
        r.memberTagCode === row.memberTagCode,
    );

    if (ruleIndex < 0) return;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Are you sure?',
        message: 'You are about to delete current loyalty redemption level rule.',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.redeemRulesCreateNewFacade.dispatch(DeleteRedemptionRule({ ruleIndex }));
      }
    });
  }

  filterInvoiceStore(element: any, columnTag: string) {
    const id = this.matchRowWithColumn(element, columnTag);
    return this.invoicesFacade.storeValuesWithLiterals.filter((store) => store.id === Number(id))[0].description;
  }

  summaryRedirect(element: any) {
    this.router.navigate(['/customers/members', element.loyaltyMemberId]);
  }

  ticketsRedirect(element: any) {
    this.router.navigate(['/customers/members', element.ticketCustomer.ticketLoyaltyMemberDto.loyaltyMemberId]);
  }

  deleteInvoice(element: any) {
    this.facade.dispatch(CancelInfoInvoice({ invoiceId: element.invoiceId }));
  }

  openInvoiceDetails(element: any) {
    this.facade.dispatch(InvoiceDetails({ gridData: element }));
    this.facade.dispatch(InvoiceModal());
  }

  openInvoiceCoupons(element: any) {
    this.facade.dispatch(InvoiceShowCoupons({ gridData: element }));
    this.facade.dispatch(InvoiceModal());
  }

  openInvoiceAttributes(element: any) {
    this.facade.dispatch(InvoiceShowAttributes({ gridData: element }));
    this.facade.dispatch(InvoiceModal());
  }

  getMeToMember(id: any) {
    this.searchCheckbooksFacadeService.dispatch(GetMeToMember({ loyaltyMemberId: id }));
  }

  unassignCheckbook() {
    this.searchCheckbooksFacadeService.dispatch(OpenDialogForUnassignCheckbook());
  }

  assignCheckbook() {
    this.searchCheckbookSidenavFacade.dispatch(AssignCheckbook({ assignCheckbook: true }));

    const displayedAssignCheckbookColumns: { [column: string]: string } = {
      ['Selected']: '',
      [this.literalsFacade.literals.literals['liquid.schema']]: this.assignCheckbookFacade.schema,
      [this.literalsFacade.literals.literals['liquid.customer.fullname']]: 'displayedName',
      ['Member']: '',
    };

    this.facade.dispatch(LoadAssignCheckbookCols({ displayedColumns: displayedAssignCheckbookColumns }));
  }

  merchantSummary(element: any) {
    this.merchantEditActions(element, 'MerchantSummaryComponent');
    this.router.navigate(['/merchant/view/summary']);
  }

  merchantDetails(element: any) {
    this.merchantEditActions(element, 'MerchantDetailsComponent');
    this.facade.dispatch(TabIndexChange());
    this.router.navigate(['/merchant/view/details']);
  }

  merchantEditActions(element: any, activeComponent: string) {
    this.facade.dispatch(ViewMerchantInfo());
    this.facade.dispatch(SearchMerchant({ element }));
    this.facade.dispatch(MerchantPageChanged());
    this.facade.dispatch(ActiveComponentChanged({ activeComponent: activeComponent }));
  }

  merchantEditStore(row: any) {
    this.router.navigate(['/store-management'], {
      queryParams: {
        storeCode: row.code,
        merchant: this.merchantSummaryFacade.qivosID,
        merchantEdit: 1,
      },
    });
  }

  merchantUnbindStore() {
    this.facade.dispatch(UnbindStoreModal());
  }

  merchantChangeStoreStatus(row: any) {
    row?.inactive
      ? this.facade.dispatch(SummaryActivateStore({ element: row }))
      : this.facade.dispatch(SummaryDeactivateStoreModal());
  }

  merchantEditCouponset(row: any) {
    this.facade.dispatch(EditCouponset({ couponSet: row }));
  }

  deactivateClub(row: ClubState) {
    if (row.deleteFlag) this.facade.dispatch(ActivateClub({ row }));
    else this.facade.dispatch(DeleteClubConfirm());
  }

  cancelCampaignExecution(row: GridCampaignSearchResponse) {
    this.facade.dispatch(CancelCampaignModal({ row }));
  }

  filterListsTarget(element: any, value: string): string {
    const target = this.listsFacadeService.targetsValuesWithLiterals.find((target) => target.id === value);
    return target ? target.description : '';
  }

  downloadList(row: any) {
    this.facade.dispatch(DownloadList({ data: row }));
  }

  showPreviewList(row: any) {
    this.facade.dispatch(SelectedRowDataChanged({ row }));
    this.facade.dispatch(ShowPreviewList());

    const isLoyaltyMember = row.campaignSelectionTarget === Target.LOYALTY_MEMBER;
    const campaignAdHocListId = this.facade.selectedRow.campaignAdHocListId;

    const displayedPreviewListColumns: { [column: string]: string } = isLoyaltyMember
      ? {
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.id']]: 'id',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.fname']]: 'firstName',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.lname']]: 'lastName',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.lcard']]: 'loyaltyCard',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.schema']]: 'schemaId',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.sms']]: 'smsOptOut',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.email']]: 'emailOptOut',
          ['Preview List Actions']: '',
        }
      : {
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.id']]: 'id',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.fname']]: 'firstName',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.lname']]: 'lastName',
          [this.literalsFacade.literals.literals['liquid.user.email']]: 'email',
          [this.literalsFacade.literals.literals['liquid.teltype.mobile']]: 'mobile',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.sms']]: 'smsOptOut',
          [this.literalsFacade.literals.literals['liquid.campaign.lists.preview.email']]: 'emailOptOut',
          ['Preview List Actions']: '',
        };

    this.facade.dispatch(LoadPreviewListCols({ displayedColumns: displayedPreviewListColumns }));
    this.facade.dispatch(PreviewListByFilter({ data: row }));
    isLoyaltyMember
      ? this.facade.dispatch(PreviewListForMembers({ campaignAdHocListId }))
      : this.facade.dispatch(PreviewListForPerson({ campaignAdHocListId }));
  }

  matchTicketStatus(id: number): string {
    return (
      this.matchTicketLiteral(
        this.ticketsSearchFacade.statusValues.filter((status: Status) => status.id === id)[0]?.description,
      ) ?? null
    );
  }

  matchTicketAssignee(id: number): string {
    return (
      this.matchTicketLiteral(
        this.ticketsSearchFacade.assigneeValues.filter((assignee: Assignment) => assignee.id === id)[0]?.description,
      ) ?? null
    );
  }

  matchTicketSeverity(id: number): string {
    return (
      this.matchTicketLiteral(
        this.ticketsSearchFacade.ticketSeverityValues.filter((severity: Severity) => severity.id === id)[0]
          ?.description,
      ) ?? null
    );
  }

  matchTicketCategory(id: number): string {
    return (
      this.matchTicketLiteral(
        this.ticketsSearchFacade.categoryValues.filter((category: Category) => category.id === id)[0]?.description,
      ) ?? null
    );
  }

  matchTicketSchema(id: number): string {
    return (
      this.ticketsSearchFacade.loyaltySchemaValues.filter((schema: Schema) => schema.id === id)[0]?.loyaltySchemaName ??
      null
    );
  }

  matchTicketLiteral(literal: string) {
    return literal ? this.literalsFacade.literals.literals[literal.toLowerCase()] : null;
  }

  matchCategoryLiteral(literal: string) {
    return literal ? this.literalsFacade.literals.literals[literal.toLowerCase()] : null;
  }

  openTicketSidenav(element: TicketRow) {
    this.facade.dispatch(
      EditTicket({
        element,
        categories: this.ticketsSearchFacade.categoryValues,
        countries: this.ticketsSearchFacade.countryValues,
        memberColumns: [this.ticketsLiterals.schema, this.ticketsLiterals.fullName, this.ticketsLiterals.ticketActions],
        statusValues: this.ticketsSearchFacade.statusValues,
        ticketAssigneeValues: this.ticketsSearchFacade.assigneeValues,
        ticketSeverityValues: this.ticketsSearchFacade.ticketSeverityValues,
      }),
    );
  }

  checkedChange(e: boolean, index: string) {
    this.facade.dispatch(ChangeCheckedStatus({ isSelected: e, id: index }));
  }

  hasTaskWithTemplateProperties(element: any) {
    let tasks = JSON.parse(element.flowTask).tasks;
    for (let i = 0; i < tasks.length; i++) {
      if (this.hasTemplateProperties(tasks[i].taskType)) {
        return true;
      }
    }

    return false;
  }

  hasTemplateProperties(taskType: any) {
    let task = null;
    for (var i = 0; i < this.searchFlowsFacade.templateProperties.length; i++) {
      if (this.searchFlowsFacade.templateProperties[i]?.taskType === taskType) {
        task = this.searchFlowsFacade.templateProperties[i];
        break;
      }
    }
    return task;
  }

  editFlow(flow: any, view?: boolean, isAdvanced?: boolean) {
    view ? this.facade.dispatch(ViewFlow({ flow })) : this.facade.dispatch(EditFlow({ flow, isAdvanced }));
    this.facade.dispatch(OpenFlowsSidenav());
  }

  deactivateFlow(element: any) {
    element.deleteFlag
      ? this.facade.dispatch(ActivateFlow({ row: element }))
      : this.facade.dispatch(DeactivateFlowModal());
  }

  changeStoreRowLangCode(id: string, languageCode: string) {
    this.facade.dispatch(TableCountryCodeChanged({ id, languageCode }));
  }

  editStore(store: EditStateRow) {
    this.facade.dispatch(EditStore({ store }));
    this.facade.dispatch(GetLocaleData());
  }

  deactivateStore(store: any) {
    store.deleteFlag ? this.facade.dispatch(ActivateStore({ store })) : this.facade.dispatch(DeactivateStoreModal());
  }

  viewMember(member: any) {
    if (this.eliquaFacadeService.activeComponent === 'AllCustomersComponent') {
      this.facade.dispatch(ViewCustomer({ customer: member }));
    } else {
      this.facade.dispatch(ViewMember({ member }));
    }
  }

  editMember(customer: any) {
    if (this.eliquaFacadeService.activeComponent === 'AllCustomersComponent') {
      this.customerSharedFacade.customerActiveTab = 'details';
      this.facade.dispatch(EditCustomer({ customer }));
    } else {
      this.customerSharedFacade.activeTab = 'details';
      this.facade.dispatch(ViewMember({ member: customer }));
    }
  }
}
